var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isNotNullOrUndefined(_vm.content.headline))?_c('div',{staticClass:"container a-headline",attrs:{"id":_vm.content.key}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"h1 mb-0 text-uppercase",class:`text-${_vm.textAlign}`},[_vm._v("\n        "+_vm._s(_vm.content.headline)+"\n      ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }